import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { API_BASE_URL } from './config';

function RegisterEmail() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setError(true);
      return;
    }

    setError(false);

    try {
      const response = await fetch(`${API_BASE_URL}/v1/email/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      console.log('API Response:', data);

      // const hashCode = data.hash_code;
      // const registerUrl = `${window.location.origin}/register?key=${hashCode}`;
      // console.log('Registration URL:', registerUrl);

      alert('登録用URLをメールに送信しました。');

    } catch (err) {
      console.error('API request failed:', err);
    }
  };

  return (
    <div className="container">
      <h2 className="mt-5">メールアドレス認証</h2>
      <form className="mt-3" onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">メールアドレス</label>
          <input
            type="email"
            className={`form-control ${error ? 'is-invalid' : ''}`}
            id="email"
            placeholder="your@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {error && (
            <div className="form-text text-danger">※有効なメールアドレスを入力してください</div>
          )}
        </div>
        <button type="submit" className="btn btn-primary">会員登録URLを送信</button>
      </form>
    </div>
  );
}

export default RegisterEmail;
